import requisites from './requisites';
import requisitesGroups from './requisites-groups';
import templates from './templates';
import workflows from './workflows';

const configuration = {
    namespaced: true,
    modules: {
        requisites,
        requisitesGroups,
        templates,
        workflows
    }
}

export default configuration;